import React, { useEffect, useState } from "react";
import api, { API } from "../lib/api";

export default function PartnerCarousel() {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    api
      .get("/partners")
      .then((r) => setPartners(r.data))
      .catch(() => setPartners([]));
  }, []);

  if (partners.length === 0) return null;

  // Duplicate for seamless infinite scroll if more than 4
  const shouldScroll = partners.length > 4;
  const list = shouldScroll ? [...partners, ...partners] : partners;

  return (
    <section className="relative z-10 py-6 md:py-8 border-t border-white/10 bg-gradient-to-b from-transparent to-black/40" data-testid="partner-carousel">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <h3 className="text-center text-sm md:text-base uppercase tracking-[0.4em] font-bold text-white mb-4">
          Partner Ufficiale di:
        </h3>

        {shouldScroll ? (
          <div className="overflow-hidden relative">
            <div className="flex gap-10 lmkt-marquee" style={{ width: "max-content" }}>
              {list.map((p, idx) => (
                <PartnerLogo key={`${p.id}-${idx}`} p={p} />
              ))}
            </div>
            <div className="absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-[#050505] to-transparent pointer-events-none" />
            <div className="absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-[#050505] to-transparent pointer-events-none" />
          </div>
        ) : (
          <div className="flex flex-wrap items-center justify-center gap-10">
            {partners.map((p) => (
              <PartnerLogo key={p.id} p={p} />
            ))}
          </div>
        )}
      </div>

      <style>{`
        @keyframes lmkt-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .lmkt-marquee {
          animation: lmkt-scroll 32s linear infinite;
        }
        .lmkt-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
}

function PartnerLogo({ p }) {
  const fullUrl = `${API}/partners/${p.id}/image`;
  return (
    <div
      className="flex items-center justify-center bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-3 transition-all hover:bg-white/10 hover:scale-[1.04]"
      style={{ width: 150, height: 150 }}
      title={p.name}
      data-testid={`partner-logo-${p.id}`}
    >
      <img
        src={fullUrl}
        alt={p.name}
        className="max-w-full max-h-full object-contain"
        style={{ maxWidth: 130, maxHeight: 130 }}
      />
    </div>
  );
}
